import React from 'react'
import { connect } from 'react-redux';
import Settings from './Settings';
import { Container } from 'shards-react';

const DefaultSettings = () => {
    return (<>
        <Container fluid className="main-content-container px-4 py-4">
            <Settings></Settings>
            
        </Container>
    </>)
}

const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, {
})(DefaultSettings);
